module.exports = __webpack_public_path__ + "static/media/Larissa.121f14c6.svg";